import {Color, Size} from '../types'
import {getColorVariant, getSizeVariant} from '../utils'

export const getSize = (size: Size): string => {
  const small = `px-12 py-8 plain-text-semibold`
  const medium = `px-16 py-12 plain-text-semibold`
  const big = `px-16 py-12 text-md-semibold`

  return getSizeVariant(size, {small, medium, big})
}

export const getSvgSize = (size: Size): number => {
  const small = 16
  const medium = 16
  const big = 24

  return getSizeVariant(size, {small, medium, big})
}

export const getDefault = (color: Color): string => {
  const primary = 'bg-action-default text-invert'
  const secondary =
    'border border-solid border-line-base bg-action-secondary-default text-secondary'
  const error = 'bg-action-attention-default text-invert'
  const warning = 'border border-solid border-warning text-grey'
  const grey = 'border border-solid border-grey-l60 text-secondary'
  const invert = 'border border-solid border-grey-l60 text-primary'

  return getColorVariant(color, {
    primary,
    secondary,
    error,
    warning,
    grey,
    invert
  })
}

export const getDisabled = (color: Color): string => {
  const primary =
    'pointer-events-none bg-action-primary-disabled text-disabled-new'
  const secondary =
    'pointer-events-none border border-solid border-line-disabled bg-action-secondary-default text-disabled-new'
  const error =
    'pointer-events-none bg-action-primary-disabled text-disabled-new'
  const warning =
    'pointer-events-none border border-solid border-warning-l60 text-grey-l60'
  const grey =
    'pointer-events-none border border-solid border-grey-l60 text-grey-l60'
  const invert = 'pointer-events-none border bg-grey-d80 text-grey-d40'

  return getColorVariant(color, {
    primary,
    secondary,
    error,
    warning,
    grey,
    invert
  })
}

export const getHover = (color: Color): string => {
  const primary = 'hover:bg-action-hover'
  const secondary = 'hover:bg-action-secondary-hover hover:text-secondary'
  const error = 'hover:bg-action-attention-hover'
  const warning =
    'hover:border hover:border-solid hover:border-warning-l20 hover:text-grey-l20'
  const grey = 'hover:border-grey-l80 hover:text-secondary'
  const invert = 'hover:bg-interactive-d20'

  return getColorVariant(color, {
    primary,
    secondary,
    error,
    warning,
    grey,
    invert
  })
}

export const getPressed = (color: Color): string => {
  const primary = 'active:bg-action-pressed'
  const secondary = 'active:bg-action-secondary-pressed'
  const error = 'active:bg-action-attention-pressed'
  const warning =
    'active:border active:border-solid active:border-warning-d20 active:text-grey-d20'
  const grey = 'active:border-grey-l60'
  const invert = 'active:bg-interactive-l100'

  return getColorVariant(color, {
    primary,
    secondary,
    error,
    warning,
    grey,
    invert
  })
}

export const getRounded = (rounded: '4' | '8'): string => {
  if (rounded === '8') {
    return 'rounded-8'
  }

  return 'rounded-4'
}
